/**
 *
 * FundingTypePicker
 *
 */

import {
  BaseOptionsPicker,
  BaseOptionsPickerProps,
} from 'app/components/BasicPickers/BaseOptionsPicker';
import { AssemblyTypes } from 'enums/InstrumentListAssemblyTypes';
import { Entity } from 'types/common';
import { enumToEntityArray } from 'utils/enumKeys';

export interface AssemblyTypePickerProps
  extends Omit<BaseOptionsPickerProps<Entity<number>>, 'getOptions'> {}

export const getSingleAssemblyType = (val: number): Entity<number> => {
  return enumToEntityArray(AssemblyTypes).filter(item => {
    return item.Id === val;
  })[0];
};

export const initAssemblyTypeData = (
  initval: number | string | undefined,
): Promise<Entity<number>[]> => {
  if (initval === undefined) {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([] as Entity<number>[]);
    });
  } else {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve(
        enumToEntityArray(AssemblyTypes).filter(item => {
          return item.Id.toString() === initval;
        }),
      );
    });
  }
};

const getOptions = (searchTerm: string | null) => {
  let items = enumToEntityArray(AssemblyTypes);
  if (searchTerm !== null && searchTerm !== '') {
    return items.filter(
      f => f.Name.startsWith(searchTerm) || f.Name.indexOf(searchTerm) !== -1,
    );
  }
  return items;
};

export function AssemblyTypePicker(props: AssemblyTypePickerProps) {
  return (
    <BaseOptionsPicker
      mini={props.mini ? true : undefined}
      size={props.size}
      getOptions={getOptions}
      value={props.value}
      {...props}
    />
  );
}
